
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shyftpass/single-class",
      function () {
        return require("private-next-pages/shyftpass/single-class/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shyftpass/single-class"])
      });
    }
  